import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Layout, Typography } from "antd";
import SmallScreenNav from "./SmallScreenNav";
import HeaderSection from "./HeaderSection";
const { Content, Footer } = Layout;

function HomeLayout({ screenWidth, toggleTheme, darkMode }) {
  const [open, setOpen] = useState(false);
  const onClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Layout style={{ minHeight: "100vh" }}>
        <HeaderSection
          screenWidth={screenWidth}
          setOpen={setOpen}
          toggleTheme={toggleTheme}
          darkMode={darkMode}
        />
        <Content
          style={{
            // margin: "0.5rem",
            padding: screenWidth < 800 ? "0" : "0.2rem 1rem",
            // minHeight: "70vh",
            overflowY: "auto",
          }}
        >
          <Outlet />
        </Content>
        <Footer style={{ padding: "0.5rem 1rem", textAlign: "center" }}>
          <Typography.Paragraph style={{ margin: 0, fontSize: "12px" }}>
            2024 Copyright by Jamir Muhumuza &#9733; All Rights reserved
          </Typography.Paragraph>
        </Footer>

        {open && <SmallScreenNav open={open} onClose={onClose} />}
      </Layout>
    </div>
  );
}

export default HomeLayout;
